import { useQueryClient } from 'react-query'
import {
  useCreateDashboardAnalytic,
  useUpdateDashboardAnalytic,
  useDeleteDashboardAnalytic
} from 'api/hooks/use-dashboard-analytics'

// Callers await the mutations and update `params` afterward, so the
// transactions refetch fires only after the DB write has committed. Without
// this ordering the GET that follows an optimistic param change can hit the
// backend before the mutation lands, and the filter appears stuck on.
//
// We still invalidate ['transactions'] on success because the dashboard
// transactions query strips `analytics` from its query key (the backend
// reads dashboard_analytics from the DB), so changing params.analytics
// alone won't trigger a refetch.
export const useAnalyticMutations = ({
  dashboardId,
  analyticId,
  currentAnalytic
}) => {
  const queryClient = useQueryClient()
  const onSuccess = () => queryClient.invalidateQueries(['transactions'])

  const { mutateAsync: createAnalytic, isLoading: isCreating } =
    useCreateDashboardAnalytic({
      params: {
        dashboard_id: dashboardId,
        analytic_id: analyticId,
        options: 'include'
      },
      options: { onSuccess }
    })

  const { mutateAsync: updateAnalytic, isLoading: isUpdating } =
    useUpdateDashboardAnalytic({
      id: currentAnalytic?.dashboard_analytic_id,
      options: { onSuccess }
    })

  const { mutateAsync: deleteAnalytic, isLoading: isDeleting } =
    useDeleteDashboardAnalytic({
      id: currentAnalytic?.dashboard_analytic_id,
      options: { onSuccess }
    })

  return {
    createAnalytic,
    updateAnalytic,
    deleteAnalytic,
    isPending: isCreating || isUpdating || isDeleting
  }
}
